import { GraphQLCall, validatedResponse } from "./helper";
import { getPatientThresholdQuery } from "./graphQl/queries";
import { savePatientThresholdMutation } from "./graphQl/mutations";

export const fetchPatientVitalThreshold = async (variables) => {
    try {
        const data = await GraphQLCall(
            getPatientThresholdQuery,
            { patientId: variables['patientId'] }
        );

        const validatedData = validatedResponse("getPatientThreshold", data);
        return validatedData;
    } catch (error) {
        console.error("Error while fetching patient list:", error.message);
        throw error;
    }
};

export const savePatientThreshold = async (variables) => {
    try {
        const data = await GraphQLCall(savePatientThresholdMutation, {
            ...variables,
            vitalType: variables['type'],
            vitalRanges: variables['data']
        });

        const validatedData = validatedResponse("savePatientThreshold", data);
        return validatedData;
    } catch (error) {
        console.error("Error while saving Threshold:", error.message);
        throw error;
    }
};
